import { Box, Spacer, TextInputNew, TextNew } from '@jfs/ui-new'
import { getRandomAlphaNumString } from '@jfs/utils'
import { useIsFocused } from '@react-navigation/native'
import { FC, useCallback, useState } from 'react'
import { otherFilters } from '../../data/models/Filters'
import { dateShortRange, filterData, subscriptionSearchData } from '../../data/static/data'
import { actionMenuStrings } from '../../data/static/strings'
import { Routes } from '../../nav/routes'
import { DateType, fromIsoDate, getYesterday, toIsoDate, toLateNight, toMidnight } from '../../util/util'
import { DropdownOptimised } from '../DropdownNew'
import { DropdownTypes } from '../DropdownNew/types'
import { ModBox } from '../ModifiedBox/ModifiedBox'
import { DateSelector } from './../../comps/DateSelection'
import { CLFilter, FilterItem } from './index'
import { styles } from './styles'
import { filterTypes } from './types'

const FilteredPeriodDefaultValue = 'createdAt'

interface SubscriptionFiltersPrps {
  checkSelected: any
  updateFilters: any
  selectedFilteredData: any
  updateOtherFilters: any
}

const SubscriptionFilters: FC<SubscriptionFiltersPrps> = ({
  checkSelected,
  updateFilters,
  selectedFilteredData,
  updateOtherFilters,
}: SubscriptionFiltersPrps) => {
  const selectedStartDate = selectedFilteredData.subscriptionStartDate
    ? fromIsoDate(selectedFilteredData.subscriptionStartDate)
    : new Date()
  const selectedEndDate = selectedFilteredData.subscriptionEndDate
    ? fromIsoDate(selectedFilteredData.subscriptionEndDate)
    : new Date()
  const selectedRangeType = selectedFilteredData.subscriptionDateRangeType
    ? selectedFilteredData.subscriptionDateRangeType
    : actionMenuStrings.today
  const isFocused = useIsFocused()
  const [calendarVisible, setCalendarVisible] = useState(false)

  const setDates = useCallback(
    (newDate) => {
      updateOtherFilters(toIsoDate(toMidnight(newDate.fromDate)), otherFilters.subscriptionStartDate)
      updateOtherFilters(toIsoDate(toLateNight(newDate?.toDate ?? new Date())), otherFilters.subscriptionEndDate)
      updateOtherFilters(newDate.rangeType, otherFilters.subscriptionDateRangeType)
      setCalendarVisible(newDate.visible)
    },
    [updateOtherFilters],
  )

  // const [dateValue, setDateValue] = useState(selectedFilteredData?.subscriptionDateRangeType)

  const themeStyles = styles()

  const obj: any = {
    'Customer Name': 'customerName',
    'Customer Email': 'customerEmail',
    'Customer Mobile Number': 'customerMobileNumber',
  }

  const objValue: any = {
    customerName: 'Customer Name',
    customerEmail: 'Customer Email',
    customerMobileNumber: 'Customer Mobile Number',
  }

  const handleOnChange = (value: any) => {
    updateOtherFilters(obj[value], otherFilters.subscriptionSearchType)
  }

  const handleSearch = (value: string) => {
    updateOtherFilters(value, otherFilters.subscriptionSearch)
  }

  const getDateValue = (value: number): Date => {
    const today = new Date(Date.now())
    return new Date(today.setDate(today.getDate() - value))
  }

  const getSelectedDate = (today: Date, value: string): Date => {
    const getSelectedValue = {
      [actionMenuStrings.today]: today,
      [actionMenuStrings.thisWeek]: getDateValue(7),
      [actionMenuStrings.customDate]: getDateValue(0),
      [actionMenuStrings.thisMonth]: getDateValue(30),
    }
    return getSelectedValue[value]
  }
  const getYesterdayValue = useCallback(() => {
    const yesterdayBegin = getYesterday('START')
    const yesterdayEnd = getYesterday('END')
    setDates({
      fromDate: yesterdayBegin,
      toDate: yesterdayEnd,
      dateLabel: actionMenuStrings.yesterday,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onDateRangeSelected = (value: string | number[]): void => {
    const dateStr = value.toString()
    // setDateValue(dateStr)
    const today = new Date(Date.now())
    if (dateStr === actionMenuStrings.yesterday) {
      getYesterdayValue()
    } else {
      const currentDay = dateStr === actionMenuStrings.customDate ? selectedEndDate : today
      const finishDay =
        dateStr === actionMenuStrings.customDate ? selectedStartDate : getSelectedDate(today, value.toString())

      setDates({
        fromDate: finishDay,
        toDate: currentDay,
        visible: dateStr === actionMenuStrings.customDate,
        rangeType: dateStr,
      })
    }
  }

  const onDateValueSelected = (dateObj: DateType): void => {
    // setDateValue(actionMenuStrings.customDate)
    setDates({
      fromDate: dateObj.fromDate,
      toDate: dateObj.toDate ?? new Date(),
      visible: false,
      rangeType: selectedRangeType,
    })
  }

  const SetNewPosition = (value: any) => {
    setDates({
      fromDate: value.fromDate,
      toDate: value?.toDate ?? new Date(),
      visible: value.position.visible,
      rangeType: selectedRangeType,
    })
  }

  const areDateFieldVisible = FilteredPeriodDefaultValue !== selectedFilteredData?.subscriptionDateType

  return (
      <Box padding={16} key={new Date().toDateString()}>
      <Box flexDirection="row" flexWrap="wrap">
        <Box f={1}>
          <TextNew type="body14" color="BLACK_21" fontFamily="jiotype-medium">
            Search By
          </TextNew>
          <Spacer size={12} direction="vertical" />
          <Box flexDirection="row" justify="space-between">
            <Box {...themeStyles.searchContainer} f={0.5}>
              <Box>
                <DropdownOptimised
                  placeHolder={objValue[selectedFilteredData?.subscriptionSearchType] ?? 'Select'}
                  showBorder={false}
                  onChange={handleOnChange}
                  iconType="SEARCH"
                  data={subscriptionSearchData}
                  type={DropdownTypes.DEFAULT_WITHOUT_BORDER}
                />
              </Box>
              <Spacer size={2} direction="horizontal" />
              <Box f={1} justifyContent="center">
                <TextInputNew
                  {...themeStyles.searchText}
                  onChange={handleSearch}
                  value={selectedFilteredData?.subscriptionSearch ?? ''}
                />
              </Box>
            </Box>
            <ModBox flexDirection="row" alignSelf="flex-start" f={0.3} show={areDateFieldVisible}>
              <DropdownOptimised
                placeHolder={selectedRangeType ? selectedRangeType : actionMenuStrings.today}
                showBorder={true}
                onChange={onDateRangeSelected}
                // value={selectedRangeType ? selectedRangeType : actionMenuStrings.today}
                data={dateShortRange}
                iconType="CALENDAR"
                type={DropdownTypes.DEFAULT_WITH_IMAGE}
              />
              <DateSelector
                value={{
                  fromDate: selectedStartDate,
                  toDate: selectedEndDate,
                  position: { visible: calendarVisible },
                }}
                isFocused={isFocused}
                path={Routes.SUBSCRIPTION_FILTER}
                onDateSelected={onDateValueSelected}
                setNewDate={SetNewPosition}
              />
            </ModBox>
          </Box>
        </Box>
      </Box>
      <Spacer size={32} direction="vertical" />
      <Box flexDirection="row" justifyContent="space-between">
        <Box>
          <FilterItem
            hide={false}
            header={'Filter by subscription status'}
            filterData={filterData}
            updateFilters={updateFilters}
            mode={filterTypes.subscriptionStatus}
            checkSelected={checkSelected}
          />
        </Box>
        <Box>
          <TextNew type="body14" color="BLACK_21" fontFamily="jiotype-medium">
            Filter by Period
          </TextNew>
          <Spacer size={8} direction="vertical" />
          <Box>
            <CLFilter
              mode={filterTypes.subscriptionDateType}
              filterData={filterData}
              updateFilters={updateFilters}
              style={themeStyles.revocable}
              selectedValue={selectedFilteredData?.subscriptionDateType}
            />
          </Box>
        </Box>
        <Box>
          <TextNew type="body14" color="BLACK_21" fontFamily="jiotype-medium">
            Filter by revocable
          </TextNew>
          <Spacer size={8} direction="vertical" />
          <Box>
            <CLFilter
              mode={filterTypes.subscriptionRevocable}
              filterData={filterData}
              updateFilters={updateFilters}
              style={themeStyles.revocable}
              selectedValue={selectedFilteredData?.subscriptionRevocable}
            />
          </Box>
        </Box>
        <Box>
          <TextNew type="body14" color="BLACK_21" fontFamily="jiotype-medium">
            Filter by payment mode
          </TextNew>
          <Spacer size={8} direction="vertical" />
          <Box>
            <CLFilter
              mode={filterTypes.subscriptionPaymentMode}
              filterData={filterData}
              updateFilters={updateFilters}
              style={themeStyles.revocable}
              selectedValue={selectedFilteredData?.subscriptionPaymentMode}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export { SubscriptionFilters }
